export const points_1_str = `
8.5, 30.5
8.5, 31.5
8.5, 32.5
9.5, 31.5
9.5, 32.5
10.5, 30.5
10.5, 31.5
11.5, 29.5
11.5, 30.5
12.5, 28.5
12.5, 29.5
13.5, 26.5
13.5, 27.5
13.5, 28.5
14.5, 25.5
14.5, 26.5
14.5, 27.5
15.5, 23.5
15.5, 24.5
15.5, 25.5
16.5, 21.5
16.5, 22.5
16.5, 23.5
17.5, 19.5
17.5, 20.5
17.5, 21.5
18.5, 16.5
18.5, 17.5
18.5, 18.5
18.5, 19.5
19.5, 14.5
19.5, 15.5
19.5, 16.5
19.5, 17.5
20.5, 12.5
20.5, 13.5
20.5, 14.5
21.5, 11.5
21.5, 12.5
21.5, 13.5
22.5, 10.5
22.5, 11.5
23.5, 10.5
23.5, 11.5
24.5, 10.5
24.5, 11.5
24.5, 25.5
24.5, 26.5
24.5, 27.5
24.5, 28.5
24.5, 29.5
24.5, 30.5
25.5, 11.5
25.5, 12.5
25.5, 13.5
25.5, 14.5
25.5, 15.5
25.5, 16.5
25.5, 17.5
25.5, 18.5
25.5, 19.5
25.5, 20.5
25.5, 21.5
25.5, 22.5
25.5, 23.5
25.5, 24.5
25.5, 25.5
25.5, 26.5
25.5, 27.5
25.5, 28.5
25.5, 29.5
25.5, 30.5
26.5, 12.5
26.5, 13.5
26.5, 14.5
26.5, 15.5
26.5, 16.5
26.5, 17.5
26.5, 18.5
26.5, 19.5
26.5, 20.5
26.5, 21.5
26.5, 22.5
26.5, 30.5
26.5, 31.5
27.5, 30.5
27.5, 31.5
28.5, 30.5
28.5, 31.5
29.5, 30.5
30.5, 30.5
31.5, 29.5
31.5, 30.5
32.5, 30.5
33.5, 18.5
33.5, 19.5
33.5, 26.5
33.5, 27.5
33.5, 28.5
33.5, 29.5
33.5, 30.5
33.5, 31.5
34.5, 18.5
34.5, 19.5
34.5, 24.5
34.5, 25.5
34.5, 26.5
34.5, 27.5
34.5, 28.5
34.5, 29.5
34.5, 30.5
34.5, 31.5
34.5, 32.5
35.5, 18.5
35.5, 19.5
35.5, 23.5
35.5, 24.5
35.5, 28.5
35.5, 32.5
35.5, 33.5
36.5, 18.5
36.5, 19.5
36.5, 22.5
36.5, 23.5
36.5, 27.5
36.5, 28.5
36.5, 32.5
36.5, 33.5
37.5, 19.5
37.5, 22.5
37.5, 23.5
37.5, 27.5
37.5, 28.5
37.5, 32.5
37.5, 33.5
38.5, 19.5
38.5, 20.5
38.5, 22.5
38.5, 23.5
38.5, 25.5
38.5, 26.5
38.5, 27.5
38.5, 32.5
39.5, 19.5
39.5, 22.5
39.5, 23.5
39.5, 24.5
39.5, 25.5
39.5, 31.5
39.5, 32.5
40.5, 19.5
40.5, 22.5
40.5, 23.5
40.5, 31.5
40.5, 32.5
41.5, 31.5
41.5, 32.5
42.5, 31.5
43.5, 30.5
43.5, 31.5
48.5, 23.5
48.5, 24.5
48.5, 25.5
48.5, 26.5
48.5, 27.5
49.5, 24.5
49.5, 25.5
49.5, 27.5
49.5, 28.5
49.5, 29.5
49.5, 30.5
50.5, 29.5
50.5, 30.5
51.5, 29.5
51.5, 30.5
52.5, 28.5
52.5, 29.5
53.5, 26.5
53.5, 27.5
53.5, 28.5
54.5, 25.5
54.5, 26.5
54.5, 27.5
55.5, 23.5
55.5, 24.5
55.5, 25.5
55.5, 26.5
55.5, 27.5
55.5, 28.5
55.5, 29.5
56.5, 24.5
56.5, 25.5
56.5, 28.5
56.5, 29.5
56.5, 30.5
57.5, 30.5
57.5, 31.5
58.5, 28.5
58.5, 29.5
58.5, 30.5
59.5, 27.5
59.5, 28.5
60.5, 26.5
60.5, 27.5
61.5, 25.5
61.5, 26.5
62.5, 25.5
62.5, 26.5
62.5, 27.5
63.5, 26.5
63.5, 27.5
63.5, 28.5
63.5, 29.5
64.5, 28.5
64.5, 29.5
64.5, 30.5
64.5, 31.5
65.5, 30.5
68.5, 26.5
68.5, 27.5
69.5, 24.5
69.5, 25.5
69.5, 26.5
69.5, 27.5
69.5, 28.5
69.5, 29.5
70.5, 24.5
70.5, 29.5
70.5, 30.5
71.5, 23.5
71.5, 24.5
71.5, 30.5
71.5, 31.5
72.5, 23.5
72.5, 24.5
72.5, 30.5
72.5, 31.5
73.5, 23.5
73.5, 28.5
73.5, 29.5
73.5, 30.5
74.5, 23.5
74.5, 24.5
74.5, 25.5
74.5, 27.5
74.5, 28.5
74.5, 29.5
75.5, 22.5
75.5, 23.5
75.5, 24.5
75.5, 25.5
75.5, 26.5
75.5, 27.5
75.5, 28.5
76.5, 23.5
76.5, 26.5
76.5, 27.5
76.5, 28.5
76.5, 29.5
76.5, 30.5
76.5, 31.5
77.5, 30.5
77.5, 31.5
`

export const points_2_str = `
32.5, 54.5
32.5, 55.5
33.5, 54.5
33.5, 55.5
34.5, 54.5
34.5, 55.5
35.5, 54.5
35.5, 55.5
35.5, 56.5
36.5, 54.5
36.5, 55.5
37.5, 53.5
37.5, 54.5
38.5, 52.5
38.5, 53.5
38.5, 54.5
39.5, 50.5
39.5, 51.5
39.5, 52.5
40.5, 48.5
40.5, 49.5
40.5, 50.5
41.5, 45.5
41.5, 46.5
41.5, 47.5
41.5, 48.5
42.5, 44.5
42.5, 45.5
42.5, 46.5
43.5, 42.5
43.5, 43.5
43.5, 44.5
44.5, 41.5
44.5, 42.5
44.5, 43.5
45.5, 40.5
45.5, 41.5
46.5, 40.5
46.5, 41.5
47.5, 40.5
47.5, 41.5
48.5, 40.5
48.5, 41.5
48.5, 49.5
48.5, 50.5
48.5, 51.5
48.5, 52.5
48.5, 53.5
48.5, 54.5
48.5, 55.5
49.5, 40.5
49.5, 41.5
49.5, 47.5
49.5, 48.5
49.5, 49.5
49.5, 50.5
49.5, 51.5
49.5, 52.5
49.5, 53.5
49.5, 54.5
49.5, 55.5
50.5, 41.5
50.5, 42.5
50.5, 43.5
50.5, 44.5
50.5, 45.5
50.5, 46.5
50.5, 47.5
50.5, 54.5
50.5, 55.5
51.5, 43.5
51.5, 44.5
51.5, 45.5
51.5, 54.5
52.5, 53.5
52.5, 54.5
55.5, 47.5
55.5, 48.5
56.5, 47.5
56.5, 48.5
56.5, 49.5
56.5, 50.5
56.5, 51.5
56.5, 52.5
56.5, 53.5
56.5, 54.5
56.5, 55.5
57.5, 49.5
57.5, 50.5
57.5, 51.5
57.5, 52.5
57.5, 53.5
57.5, 54.5
57.5, 55.5
58.5, 51.5
59.5, 51.5
60.5, 51.5
61.5, 51.5
62.5, 50.5
62.5, 51.5
62.5, 52.5
62.5, 53.5
62.5, 54.5
63.5, 49.5
63.5, 50.5
63.5, 54.5
63.5, 55.5
64.5, 48.5
64.5, 49.5
64.5, 54.5
64.5, 55.5
65.5, 48.5
65.5, 49.5
65.5, 54.5
65.5, 55.5
66.5, 47.5
66.5, 48.5
66.5, 49.5
66.5, 52.5
66.5, 53.5
66.5, 54.5
66.5, 55.5
67.5, 48.5
67.5, 49.5
67.5, 50.5
67.5, 51.5
67.5, 52.5
67.5, 53.5
68.5, 49.5
68.5, 50.5
68.5, 51.5
70.5, 46.5
71.5, 44.5
71.5, 45.5
71.5, 46.5
71.5, 47.5
71.5, 51.5
71.5, 52.5
71.5, 53.5
72.5, 43.5
72.5, 44.5
72.5, 47.5
72.5, 48.5
72.5, 50.5
72.5, 51.5
72.5, 53.5
72.5, 54.5
73.5, 43.5
73.5, 47.5
73.5, 48.5
73.5, 49.5
73.5, 50.5
73.5, 54.5
73.5, 55.5
74.5, 42.5
74.5, 43.5
74.5, 47.5
74.5, 48.5
74.5, 49.5
74.5, 54.5
75.5, 42.5
75.5, 43.5
75.5, 47.5
75.5, 48.5
75.5, 52.5
75.5, 53.5
75.5, 54.5
76.5, 42.5
76.5, 43.5
76.5, 47.5
76.5, 48.5
76.5, 49.5
76.5, 50.5
76.5, 51.5
76.5, 52.5
77.5, 43.5
77.5, 48.5
77.5, 49.5
77.5, 50.5
81.5, 48.5
81.5, 49.5
81.5, 50.5
82.5, 50.5
82.5, 51.5
82.5, 52.5
83.5, 52.5
83.5, 53.5
83.5, 54.5
84.5, 53.5
84.5, 54.5
84.5, 55.5
85.5, 53.5
85.5, 54.5
85.5, 55.5
86.5, 51.5
86.5, 52.5
86.5, 53.5
87.5, 49.5
87.5, 50.5
87.5, 51.5
88.5, 49.5
88.5, 50.5
89.5, 49.5
89.5, 50.5
89.5, 51.5
89.5, 52.5
90.5, 52.5
90.5, 53.5
90.5, 54.5
90.5, 55.5
91.5, 54.5
91.5, 55.5
92.5, 49.5
92.5, 50.5
93.5, 48.5
93.5, 49.5
93.5, 50.5
94.5, 47.5
94.5, 48.5
95.5, 46.5
95.5, 47.5
96.5, 46.5
96.5, 49.5
96.5, 50.5
96.5, 51.5
96.5, 52.5
97.5, 45.5
97.5, 46.5
97.5, 51.5
97.5, 52.5
97.5, 53.5
97.5, 54.5
97.5, 55.5
98.5, 45.5
98.5, 46.5
98.5, 54.5
99.5, 45.5
100.5, 45.5
101.5, 45.5
`

export const points_3_str = `
57.5, 71.5
57.5, 72.5
58.5, 70.5
58.5, 71.5
58.5, 72.5
58.5, 78.5
58.5, 79.5
58.5, 80.5
59.5, 69.5
59.5, 70.5
59.5, 72.5
59.5, 73.5
59.5, 78.5
59.5, 79.5
59.5, 80.5
60.5, 68.5
60.5, 69.5
60.5, 72.5
60.5, 73.5
60.5, 77.5
60.5, 78.5
60.5, 80.5
61.5, 68.5
61.5, 69.5
61.5, 73.5
61.5, 77.5
61.5, 78.5
61.5, 79.5
61.5, 80.5
62.5, 67.5
62.5, 68.5
62.5, 73.5
62.5, 74.5
62.5, 78.5
62.5, 79.5
63.5, 67.5
63.5, 68.5
63.5, 73.5
63.5, 74.5
63.5, 77.5
63.5, 78.5
63.5, 79.5
64.5, 67.5
64.5, 68.5
64.5, 70.5
64.5, 73.5
64.5, 74.5
64.5, 76.5
64.5, 77.5
64.5, 78.5
64.5, 79.5
65.5, 67.5
65.5, 68.5
65.5, 69.5
65.5, 70.5
65.5, 71.5
65.5, 72.5
65.5, 73.5
65.5, 74.5
65.5, 75.5
65.5, 76.5
65.5, 78.5
65.5, 79.5
66.5, 67.5
66.5, 68.5
66.5, 69.5
66.5, 70.5
66.5, 71.5
66.5, 72.5
66.5, 73.5
66.5, 74.5
66.5, 78.5
66.5, 79.5
67.5, 67.5
67.5, 68.5
67.5, 70.5
67.5, 71.5
67.5, 72.5
67.5, 78.5
67.5, 79.5
68.5, 67.5
68.5, 68.5
68.5, 78.5
68.5, 79.5
69.5, 67.5
69.5, 68.5
69.5, 77.5
69.5, 78.5
70.5, 68.5
70.5, 76.5
70.5, 77.5
71.5, 68.5
71.5, 74.5
71.5, 75.5
71.5, 76.5
72.5, 68.5
72.5, 69.5
72.5, 71.5
72.5, 72.5
72.5, 73.5
72.5, 74.5
73.5, 68.5
73.5, 69.5
73.5, 70.5
73.5, 71.5
73.5, 72.5
73.5, 75.5
73.5, 76.5
73.5, 77.5
74.5, 74.5
74.5, 75.5
74.5, 76.5
74.5, 77.5
74.5, 78.5
74.5, 79.5
75.5, 74.5
75.5, 75.5
75.5, 79.5
75.5, 80.5
76.5, 74.5
76.5, 80.5
77.5, 74.5
77.5, 77.5
77.5, 80.5
77.5, 81.5
78.5, 74.5
78.5, 75.5
78.5, 76.5
78.5, 77.5
78.5, 80.5
78.5, 81.5
79.5, 74.5
79.5, 75.5
79.5, 76.5
79.5, 78.5
79.5, 79.5
79.5, 80.5
80.5, 76.5
80.5, 77.5
80.5, 78.5
80.5, 79.5
81.5, 75.5
81.5, 76.5
81.5, 77.5
81.5, 78.5
81.5, 79.5
82.5, 78.5
82.5, 79.5
82.5, 80.5
83.5, 80.5
83.5, 81.5
83.5, 82.5
84.5, 80.5
84.5, 81.5
86.5, 76.5
86.5, 77.5
86.5, 78.5
87.5, 78.5
87.5, 79.5
88.5, 79.5
88.5, 80.5
89.5, 80.5
89.5, 81.5
90.5, 79.5
90.5, 80.5
90.5, 81.5
91.5, 77.5
91.5, 78.5
91.5, 79.5
92.5, 76.5
92.5, 77.5
92.5, 78.5
93.5, 77.5
93.5, 78.5
93.5, 79.5
94.5, 79.5
94.5, 80.5
95.5, 80.5
95.5, 81.5
96.5, 79.5
96.5, 80.5
96.5, 81.5
97.5, 77.5
97.5, 78.5
97.5, 79.5
97.5, 80.5
98.5, 76.5
98.5, 77.5
98.5, 78.5
99.5, 74.5
99.5, 75.5
99.5, 76.5
99.5, 77.5
99.5, 78.5
99.5, 79.5
100.5, 74.5
100.5, 75.5
100.5, 76.5
100.5, 77.5
100.5, 78.5
100.5, 79.5
100.5, 80.5
101.5, 80.5
101.5, 81.5
101.5, 82.5
104.5, 75.5
104.5, 76.5
104.5, 77.5
105.5, 75.5
105.5, 76.5
105.5, 77.5
105.5, 78.5
105.5, 85.5
105.5, 86.5
105.5, 87.5
106.5, 77.5
106.5, 78.5
106.5, 83.5
106.5, 84.5
106.5, 85.5
106.5, 86.5
106.5, 87.5
107.5, 78.5
107.5, 82.5
107.5, 83.5
107.5, 84.5
107.5, 87.5
107.5, 88.5
108.5, 78.5
108.5, 79.5
108.5, 81.5
108.5, 82.5
108.5, 87.5
108.5, 88.5
109.5, 78.5
109.5, 79.5
109.5, 80.5
109.5, 81.5
109.5, 87.5
109.5, 88.5
110.5, 76.5
110.5, 77.5
110.5, 78.5
110.5, 81.5
110.5, 82.5
110.5, 83.5
110.5, 87.5
110.5, 88.5
111.5, 75.5
111.5, 76.5
111.5, 77.5
111.5, 83.5
111.5, 84.5
111.5, 87.5
112.5, 73.5
112.5, 74.5
112.5, 75.5
112.5, 76.5
112.5, 77.5
112.5, 78.5
112.5, 79.5
112.5, 80.5
112.5, 81.5
112.5, 82.5
112.5, 85.5
112.5, 86.5
112.5, 87.5
113.5, 73.5
113.5, 74.5
113.5, 75.5
113.5, 76.5
113.5, 77.5
113.5, 81.5
113.5, 82.5
113.5, 83.5
113.5, 84.5
113.5, 85.5
113.5, 86.5
113.5, 87.5
114.5, 73.5
114.5, 74.5
114.5, 84.5
114.5, 85.5
114.5, 86.5
122.5, 64.5
122.5, 65.5
122.5, 66.5
122.5, 67.5
123.5, 65.5
123.5, 66.5
123.5, 67.5
123.5, 68.5
123.5, 69.5
123.5, 70.5
123.5, 71.5
123.5, 72.5
123.5, 73.5
123.5, 74.5
123.5, 75.5
123.5, 76.5
124.5, 70.5
124.5, 71.5
124.5, 72.5
124.5, 73.5
124.5, 74.5
124.5, 75.5
124.5, 79.5
124.5, 80.5
125.5, 78.5
125.5, 79.5
132.5, 62.5
132.5, 63.5
132.5, 64.5
132.5, 65.5
133.5, 64.5
133.5, 65.5
133.5, 66.5
133.5, 67.5
133.5, 68.5
133.5, 69.5
133.5, 77.5
134.5, 67.5
134.5, 68.5
134.5, 69.5
134.5, 70.5
134.5, 71.5
134.5, 72.5
134.5, 73.5
134.5, 76.5
134.5, 77.5
135.5, 77.5
140.5, 63.5
140.5, 64.5
140.5, 65.5
141.5, 63.5
141.5, 65.5
141.5, 66.5
141.5, 67.5
141.5, 68.5
142.5, 66.5
142.5, 67.5
142.5, 68.5
142.5, 69.5
142.5, 70.5
142.5, 71.5
142.5, 72.5
142.5, 73.5
142.5, 78.5
143.5, 77.5
143.5, 78.5
`

export const points_heart_str = `
118.5, 27.5
118.5, 28.5
118.5, 29.5
118.5, 30.5
118.5, 31.5
118.5, 32.5
118.5, 33.5
118.5, 34.5
118.5, 35.5
118.5, 36.5
118.5, 37.5
119.5, 25.5
119.5, 26.5
119.5, 27.5
119.5, 37.5
119.5, 38.5
119.5, 39.5
120.5, 24.5
120.5, 25.5
120.5, 39.5
120.5, 40.5
121.5, 23.5
121.5, 24.5
121.5, 40.5
121.5, 41.5
121.5, 42.5
122.5, 23.5
122.5, 43.5
122.5, 44.5
122.5, 45.5
123.5, 23.5
123.5, 45.5
123.5, 46.5
123.5, 47.5
124.5, 23.5
124.5, 47.5
124.5, 48.5
125.5, 22.5
125.5, 23.5
125.5, 48.5
125.5, 49.5
126.5, 22.5
126.5, 23.5
126.5, 49.5
127.5, 22.5
127.5, 23.5
127.5, 50.5
127.5, 51.5
128.5, 23.5
128.5, 48.5
128.5, 49.5
128.5, 50.5
129.5, 24.5
129.5, 25.5
129.5, 47.5
129.5, 48.5
130.5, 25.5
130.5, 26.5
130.5, 27.5
130.5, 46.5
130.5, 47.5
131.5, 27.5
131.5, 28.5
131.5, 29.5
131.5, 30.5
131.5, 31.5
131.5, 44.5
131.5, 45.5
132.5, 27.5
132.5, 28.5
132.5, 29.5
132.5, 30.5
132.5, 43.5
132.5, 44.5
133.5, 26.5
133.5, 27.5
133.5, 42.5
133.5, 43.5
134.5, 25.5
134.5, 26.5
134.5, 41.5
134.5, 42.5
135.5, 24.5
135.5, 25.5
135.5, 39.5
135.5, 40.5
135.5, 41.5
136.5, 24.5
136.5, 38.5
136.5, 39.5
137.5, 24.5
137.5, 37.5
137.5, 38.5
138.5, 23.5
138.5, 24.5
138.5, 36.5
138.5, 37.5
139.5, 23.5
139.5, 24.5
139.5, 35.5
139.5, 36.5
140.5, 24.5
140.5, 33.5
140.5, 34.5
141.5, 24.5
141.5, 25.5
141.5, 32.5
141.5, 33.5
142.5, 25.5
142.5, 26.5
142.5, 27.5
142.5, 28.5
142.5, 29.5
142.5, 30.5
142.5, 31.5
142.5, 32.5
143.5, 27.5
143.5, 28.5
143.5, 29.5
143.5, 30.5
`
export const pedals_str = `
69.5, 29.5
69.5, 30.5
69.5, 31.5
69.5, 32.5
70.5, 28.5
70.5, 29.5
70.5, 33.5
70.5, 34.5
71.5, 26.5
71.5, 27.5
71.5, 28.5
71.5, 34.5
72.5, 25.5
72.5, 34.5
72.5, 35.5
73.5, 24.5
73.5, 25.5
73.5, 34.5
73.5, 35.5
74.5, 24.5
74.5, 34.5
74.5, 35.5
75.5, 24.5
75.5, 34.5
76.5, 24.5
76.5, 34.5
76.5, 43.5
76.5, 44.5
76.5, 45.5
76.5, 46.5
77.5, 24.5
77.5, 34.5
77.5, 40.5
77.5, 41.5
77.5, 42.5
77.5, 43.5
77.5, 46.5
77.5, 47.5
78.5, 24.5
78.5, 34.5
78.5, 39.5
78.5, 40.5
78.5, 47.5
79.5, 24.5
79.5, 34.5
79.5, 35.5
79.5, 36.5
79.5, 37.5
79.5, 38.5
79.5, 47.5
80.5, 24.5
80.5, 33.5
80.5, 34.5
80.5, 35.5
80.5, 47.5
80.5, 48.5
81.5, 24.5
81.5, 47.5
82.5, 24.5
82.5, 25.5
82.5, 47.5
83.5, 25.5
83.5, 46.5
84.5, 25.5
84.5, 26.5
84.5, 46.5
85.5, 26.5
85.5, 27.5
85.5, 41.5
85.5, 42.5
85.5, 43.5
85.5, 44.5
85.5, 45.5
86.5, 22.5
86.5, 23.5
86.5, 24.5
86.5, 25.5
86.5, 26.5
86.5, 27.5
86.5, 28.5
86.5, 37.5
86.5, 38.5
86.5, 39.5
86.5, 40.5
86.5, 41.5
86.5, 42.5
87.5, 19.5
87.5, 20.5
87.5, 21.5
87.5, 22.5
87.5, 23.5
88.5, 17.5
88.5, 18.5
88.5, 19.5
88.5, 37.5
88.5, 38.5
88.5, 39.5
88.5, 40.5
89.5, 16.5
89.5, 17.5
89.5, 38.5
89.5, 40.5
89.5, 41.5
90.5, 15.5
90.5, 16.5
90.5, 41.5
90.5, 42.5
91.5, 14.5
91.5, 15.5
91.5, 42.5
91.5, 43.5
92.5, 14.5
92.5, 43.5
92.5, 44.5
93.5, 14.5
93.5, 45.5
94.5, 13.5
94.5, 14.5
94.5, 45.5
94.5, 46.5
95.5, 13.5
95.5, 14.5
95.5, 26.5
95.5, 27.5
95.5, 28.5
95.5, 30.5
95.5, 36.5
95.5, 45.5
95.5, 46.5
96.5, 14.5
96.5, 23.5
96.5, 24.5
96.5, 25.5
96.5, 26.5
96.5, 29.5
96.5, 30.5
96.5, 36.5
96.5, 37.5
96.5, 38.5
96.5, 45.5
96.5, 46.5
97.5, 14.5
97.5, 15.5
97.5, 16.5
97.5, 17.5
97.5, 18.5
97.5, 19.5
97.5, 20.5
97.5, 21.5
97.5, 22.5
97.5, 23.5
97.5, 28.5
97.5, 29.5
97.5, 30.5
97.5, 37.5
97.5, 38.5
97.5, 45.5
97.5, 46.5
98.5, 27.5
98.5, 37.5
98.5, 38.5
98.5, 39.5
98.5, 44.5
98.5, 45.5
99.5, 27.5
99.5, 37.5
99.5, 39.5
99.5, 40.5
99.5, 41.5
99.5, 42.5
99.5, 43.5
99.5, 44.5
100.5, 27.5
100.5, 37.5
101.5, 27.5
101.5, 36.5
101.5, 37.5
102.5, 27.5
102.5, 36.5
102.5, 37.5
103.5, 27.5
103.5, 36.5
104.5, 28.5
104.5, 29.5
104.5, 35.5
104.5, 36.5
105.5, 29.5
105.5, 30.5
105.5, 31.5
105.5, 32.5
105.5, 33.5
105.5, 34.5
105.5, 35.5
`

export const center_str = `
85.5, 32.5
85.5, 33.5
85.5, 34.5
85.5, 35.5
85.5, 36.5
85.5, 37.5
86.5, 28.5
86.5, 29.5
86.5, 31.5
86.5, 32.5
86.5, 33.5
86.5, 34.5
86.5, 35.5
86.5, 36.5
86.5, 37.5
86.5, 38.5
87.5, 30.5
87.5, 32.5
87.5, 33.5
87.5, 34.5
87.5, 35.5
87.5, 36.5
87.5, 37.5
88.5, 29.5
88.5, 30.5
88.5, 31.5
88.5, 32.5
88.5, 33.5
88.5, 34.5
88.5, 35.5
88.5, 36.5
88.5, 37.5
88.5, 38.5
89.5, 29.5
89.5, 30.5
89.5, 31.5
89.5, 32.5
89.5, 33.5
89.5, 34.5
89.5, 35.5
89.5, 36.5
89.5, 37.5
89.5, 38.5
90.5, 29.5
90.5, 30.5
90.5, 31.5
90.5, 32.5
90.5, 33.5
90.5, 34.5
90.5, 35.5
90.5, 36.5
90.5, 37.5
91.5, 29.5
91.5, 30.5
91.5, 31.5
91.5, 32.5
91.5, 33.5
91.5, 34.5
91.5, 35.5
91.5, 36.5
91.5, 37.5
92.5, 29.5
92.5, 30.5
92.5, 31.5
92.5, 32.5
92.5, 33.5
92.5, 34.5
92.5, 35.5
92.5, 36.5
93.5, 30.5
93.5, 31.5
93.5, 32.5
93.5, 33.5
93.5, 34.5
93.5, 35.5
94.5, 30.5
94.5, 31.5
94.5, 32.5
94.5, 33.5
94.5, 34.5
95.5, 28.5
95.5, 30.5
95.5, 31.5
95.5, 32.5
95.5, 33.5
96.5, 29.5
96.5, 30.5
96.5, 31.5
`

export const leaves_str = `
55.5, 68.5
55.5, 69.5
55.5, 71.5
55.5, 73.5
55.5, 74.5
55.5, 75.5
55.5, 76.5
56.5, 68.5
56.5, 77.5
56.5, 78.5
57.5, 69.5
57.5, 79.5
57.5, 87.5
58.5, 69.5
58.5, 70.5
58.5, 80.5
58.5, 81.5
58.5, 82.5
58.5, 86.5
59.5, 70.5
59.5, 71.5
59.5, 79.5
59.5, 80.5
59.5, 81.5
59.5, 82.5
59.5, 85.5
60.5, 72.5
60.5, 73.5
60.5, 76.5
60.5, 77.5
60.5, 78.5
60.5, 81.5
60.5, 82.5
60.5, 83.5
60.5, 84.5
61.5, 74.5
61.5, 75.5
61.5, 82.5
61.5, 83.5
62.5, 80.5
62.5, 81.5
63.5, 79.5
63.5, 80.5
63.5, 81.5
64.5, 63.5
64.5, 78.5
64.5, 79.5
65.5, 59.5
65.5, 60.5
65.5, 61.5
65.5, 64.5
65.5, 65.5
65.5, 77.5
65.5, 78.5
66.5, 58.5
66.5, 65.5
66.5, 66.5
66.5, 75.5
66.5, 76.5
67.5, 57.5
67.5, 66.5
67.5, 67.5
67.5, 68.5
67.5, 74.5
67.5, 75.5
68.5, 57.5
68.5, 68.5
68.5, 73.5
68.5, 74.5
69.5, 57.5
69.5, 68.5
69.5, 69.5
69.5, 72.5
69.5, 73.5
70.5, 58.5
70.5, 68.5
70.5, 69.5
70.5, 70.5
70.5, 71.5
71.5, 58.5
71.5, 59.5
71.5, 65.5
71.5, 66.5
71.5, 67.5
71.5, 68.5
71.5, 69.5
71.5, 70.5
72.5, 60.5
72.5, 61.5
72.5, 62.5
72.5, 63.5
72.5, 64.5
72.5, 68.5
72.5, 69.5
72.5, 70.5
73.5, 67.5
73.5, 68.5
73.5, 69.5
73.5, 70.5
73.5, 71.5
74.5, 66.5
74.5, 67.5
74.5, 68.5
74.5, 69.5
74.5, 72.5
75.5, 65.5
75.5, 68.5
75.5, 73.5
76.5, 63.5
76.5, 64.5
76.5, 67.5
76.5, 73.5
77.5, 62.5
77.5, 63.5
77.5, 67.5
77.5, 73.5
78.5, 60.5
78.5, 61.5
78.5, 66.5
78.5, 73.5
79.5, 59.5
79.5, 60.5
79.5, 66.5
79.5, 73.5
80.5, 58.5
80.5, 59.5
80.5, 65.5
80.5, 73.5
81.5, 57.5
81.5, 58.5
81.5, 65.5
81.5, 72.5
82.5, 55.5
82.5, 56.5
82.5, 66.5
82.5, 72.5
83.5, 54.5
83.5, 55.5
83.5, 66.5
83.5, 67.5
83.5, 70.5
83.5, 71.5
84.5, 52.5
84.5, 53.5
84.5, 68.5
84.5, 69.5
84.5, 70.5
85.5, 42.5
85.5, 43.5
85.5, 44.5
85.5, 45.5
85.5, 49.5
85.5, 50.5
85.5, 51.5
86.5, 42.5
86.5, 45.5
86.5, 46.5
86.5, 47.5
86.5, 48.5
87.5, 43.5
87.5, 44.5
87.5, 45.5
87.5, 46.5
`
